import { Card, Col, Row } from "react-bootstrap";


export default function OrderLock() {

    return (
        <div>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Order Module</h4>
                            </div>
                        </Card.Header>

                        <Card.Body>
                            <div className="text-center">
                                <i className="fa fa-lock" style={{ fontSize: "20em" }}></i>
                                <h2 className="mb-0 mt-4">Oops! Order Module is Locked.</h2>
                                <p className="mt-2">Sorry, you do not have access to this module.</p>
                                <h3 className="mt-4">Want to Activate Order Module?</h3>
                                <p className="mt-2">Contact at <a href="mailto:business@6thlabs.com" className="ms-2">
                                    <i className="fa fa-envelope me-1"></i>
                                    business@6thlabs.com
                                </a> or <a href="tel:+918401499906" className="ms-2">
                                        <i className="fa fa-phone me-1"></i>
                                        +91 84014 99906
                                    </a>
                                </p>
                            </div>
                        </Card.Body>

                    </Card>
                </Col>
            </Row>
        </div>
    )
}